import { isUserAuthenticated } from "@/middleware/auth";
import { addChatToLocalDB } from "@/indexedDB/services/chats";

import { ChatEntity, InitChatStatus } from "@/indexedDB/types";

import { SocketEventActionType, ChatWithMembersEventType } from "./types";
import { ChatType } from "@/server/types/chat";
import { queryClient } from "@/queryClient";
import { MemberRole } from "@/server/types/member";
import { extractTimestampFromUUID7 } from "@/utils/uuid7";

export const handleChatWithMembersEvent = async (
  data: ChatWithMembersEventType,
) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  switch (data.action) {
    case SocketEventActionType.CREATE:
      await onCreateGroupChat({ eventPayload: data });
      break;
    case SocketEventActionType.UPDATE:
      break;

    default:
      break;
  }
};

const onCreateGroupChat = async ({
  eventPayload,
}: {
  eventPayload: ChatWithMembersEventType;
}) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  const roleAsMemberData = eventPayload.chat_members.members.find(
    (member) => member.username === userFingerPrint.username,
  );

  if (!roleAsMemberData) {
    return;
  }

  const newGroupChat: ChatEntity = {
    id: eventPayload.chat_members.chat.id,
    hubId: eventPayload.chat_members.chat.hub_id,
    eCSK: roleAsMemberData.secure_payload,
    currentEpoch: eventPayload.chat_members.chat.current_epoch ?? 0,
    name: eventPayload.chat_members.chat.name,
    type: ChatType.GROUP,
    avatar: {
      attachmentId: eventPayload.chat_members.chat.picture,
    },
    timestamp: eventPayload.chat_members.chat.timestamp,
    // lastSyncedAt: new Date().toISOString(),
    lastSyncedAt: extractTimestampFromUUID7(eventPayload.chat_members.chat.id),
    memberCount: eventPayload.chat_members.chat.member_count,
    unreadCount: 0,
    isMuted: false,
    isPinned: false,
    isArchived: false,
    isPublic: eventPayload.chat_members.chat.is_searchable,
    description: eventPayload.chat_members.chat.description,
    allowThreads: !!eventPayload.chat_members.chat.threads_enabled,
    canPost:
      eventPayload.chat_members.chat.can_post === null
        ? MemberRole.MEMBER
        : eventPayload.chat_members.chat.can_post,

    initStatus: InitChatStatus.SUCCESS,
    roleAsMember: {
      username: roleAsMemberData.username,
      role: roleAsMemberData.role,
    },
    lastMessage: null,
    lastMessageTimestamp: eventPayload.chat_members.chat.last_message?.id
      ? extractTimestampFromUUID7(
          eventPayload.chat_members.chat.last_message.id,
        )
      : new Date().toISOString(),
    firstPhaseMsgListInit: true,
    fullMsgListInit: true,
  };

  await addChatToLocalDB(newGroupChat);

  // invalidate the query for the current user's public chats
  queryClient.invalidateQueries({
    queryKey: ["admin-user-public-chat"],
  });

  // TO DO => globakl notifications layer with settings and stuff - this is just for testing purpose
  //       if (Notification.permission === 'granted') {
  //   new Notification('New message received!', {
  //     body: 'Click to open chat',
  //     icon: '/icon.png',
  //   });

  //   playNotificationSound();
  // } else {
  //   Notification.requestPermission();

  // const audio = new Audio(
  //   `${process.env.PUBLIC_URL}/sounds/notification-2.mp3`,
  // );
  // /* eslint-disable no-console */
  // audio.play().catch((error) => console.log("Audio playback failed:", error));
};
